import React from 'react';
import { Box, Typography } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';

const ViewAll = ({ theme, ...props }) => {
  const primaryColor = theme?.palette?.primary?.main || '#1976d2';

  return (
    <Box display="flex" justifyContent="center" width="100%" mt={1} {...props}>
      <Box
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        px={2.5}
        py={1}
        borderRadius={4}
        bgcolor={primaryColor}
        minWidth={160}
      >
        <Typography variant="caption" style={{ color: '#ffffff', fontWeight: 600 }}>
          <IntlMessages id="ui.searchExperienceV2.core.blocks.viewAll.viewAllResults" />
        </Typography>
      </Box>
    </Box>
  );
};

export default ViewAll;
